
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://iwnokirxhlgxdheiocci.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml3bm9raXJ4aGxneGRoZWlvY2NpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkxNTk2NjcsImV4cCI6MjA2NDczNTY2N30.Z4yy9sapBANgLsj2gWTVwTCDWz2As5XwohptFQm-maE'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
  }
})
